import React from 'react';
import { globalStore } from 'stores';

import identity from '../../lib/identity';

import menu from '../../lib/menu';
import room from '../../lib/room';
import UserPanel from '../user-panel';
import { StyledNickname } from './styled';

// import {RichLevel} from 'components'

const NickName = (props) => {
  let { id, nickName, color = '' } = props;
  const {
    user,
    children,
    disableClick = false,
    tipMe,
    className = '',
    newUserMenu = false,
  } = props;
  let isOpenMystic = false;
  if (user) {
    id = user._id || user.id || user.uid;
    if (user.mystic && user.mystic.open) {
      isOpenMystic = true;
      nickName = user.mystic.nick_name || '-';
    } else {
      nickName = user.nick_name || user.nickname || '-';
    }
    if (tipMe && globalStore.userId === id) {
      nickName = `${nickName} (我)`;
    }
    color = identity.getNickNameColor(user);
  }
  const onClick = (e) => {
    const { id } = e.currentTarget.dataset;
    if (id && !disableClick) {
      if (window.inPcClient) {
        UserPanel.show(id, {
          isOpenMystic,
        });
        e.stopPropagation();
      } else {
        menu.show(parseInt(id, 10), {
          isOpenMystic,
          newUserMenu,
        });
      }
    }
    // request.api.get(`zone/user_info/${id}`)
    //   .then((res) => {
    //     store.popupUserInfo = res.data
    //   })
  };

  return (
    <StyledNickname
      data-id={id}
      data-mystic={isOpenMystic}
      className={`mt-nickname ${color} ${id && !disableClick ? 'cursor' : ''} ${className}`}
      onClick={onClick}
    >
      {nickName || children}
    </StyledNickname>
  );
};

// 1:运营 2:主播 3:普通用户 4:客服 5:代理
const IdenPriv = ({ priv = 0, broker = 0, guild_priv = 0, isRoomOwner }) => {
  if (priv === 3 || !priv) {
    return '';
  }

  let icon = '';
  let title = '';

  switch (priv) {
    case 1:
      icon = 'operation';
      title = '运营';
      break;
    case 2:
      if (isRoomOwner) {
        icon = 'star';
        title = '本场主播';
      } else {
        icon = 'other-star';
        title = '主播';
      }
      break;
    case 3: // 普通用户不显示
      return '';
    case 4: // 客服不显示
      return '';
    // icon = 'kefu';
    // title = '客服';
    // break;
    case 5:
      // if (broker && broker === 1) {
      icon = 'proxy';
      title = '经纪人';
      // } else if (guild_priv && guild_priv === 1) {
      //   icon = 'proxy-guild';
      //   title = '公会经纪人';
      // } else {
      //   return '';
      // }
      break;
    case 6:
      icon = 'gm';
      title = '巡警';
      break;
    default:
      break;
  }

  return <i className={`iden-icon-v2 iden-${icon}`} title={title} />;
};

const IdenGuard = () => {
  return <i className="iden-icon-v2 iden-guard" title="守护" />;
};

const IdenAdmin = () => {
  return <i className="iden-icon-v2 iden-admin" title="管理员" />;
};

const IdenIos = () => {
  return (
    <i className="iden-icon-v2 iden-text iden-ios" title="iOS用户">
      IOS
    </i>
  );
};

const IdenAndroid = () => {
  return (
    <i className="iden-icon-v2 iden-text iden-android" title="Android用户">
      安卓
    </i>
  );
};

// topIndex  1 2 3
const IdenCost = ({ topIndex }) => {
  if (topIndex < 1 || topIndex > 3) {
    return null;
  }
  const titles = ['', '本场消费最高', '本场消费第二高', '本场消费第三高'];
  return <i className={`iden-icon-v2 iden-cost-${topIndex}`} title={titles[topIndex]} />;
};

const IdenLoveGroup = () => {
  return null;
};

const IdenMedal = () => {
  return null;
};

const IdenNewUser = (props) => {
  // const { new_user_level } = props;
  // if (new_user_level > 1) {
  //   return (
  //     <i
  //       className={`iden-icon-v2 iden-new-user-${new_user_level}`}
  //       title={new_user_level === 2 ? '活跃新人' : '潜力新人'}
  //     />
  //   );
  // }
  return <i className="iden-icon-v2 iden-new-v2" title="新用户" />;
};

/**
 * vip 标识
 * @param vip  vip 值
 * @returns {null|*}
 * @constructor
 */
const IdenVip = ({ vip }) => {
  if (!vip) {
    return null;
  }
  return <i className="iden-icon-v2 iden-vip" title="VIP" />;
};

/**
 * 靓号标识
 * @param userId
 * @param mmNo
 * @param hideNum   是否隐藏数字
 * @param priceType   靓号价格类型 【1~4】
 * @returns {null|*}
 * @constructor
 */
const IdenNum = ({ userId, mmNo, priceType = 1, hideNum = false }) => {
  if (!userId || !mmNo || userId === mmNo) {
    return null;
  }

  if (hideNum) {
    return <i className="iden-icon-v2 iden-num" />;
  }

  return (
    <span className={`iden-icon-v2 iden-mm-no no-len${`${mmNo}`.length} no-price${priceType}`}>
      {mmNo}
    </span>
  );

  // return (
  //   <span className="iden-span-num" title="靓号">
  //     <i className="iden-icon-v2 iden-num"></i>
  //     <span>{mmNo}</span>
  //   </span>
  // );
};

const HiddenMan = () => {
  return <span className="mt-nickname">神秘人</span>;
};

const IdenFamily = (props) => {
  const { badgeName, isFirst } = props;
  return (
    <span
      className={`iden-icon-v2 ${isFirst ? 'iden-first-family' : 'iden-family'}`}
      title={badgeName}
    >
      {badgeName}
    </span>
  );
};

// 神秘人标识
const IdenMystic = (props) => {
  const { pic = 'https://img-photo.sumeme.com/emoji/pszemj5x.png', title } = props;
  return (
    <div className="iden-icon-v2 iden-mystic">
      <div className="iden-mystic-bg">
        <img src={pic} alt="" />
        <span>{title}</span>
      </div>
    </div>
  );
};

const IdenHonorFans = () => {
  return <i className="iden-icon-v2 iden-honour-fans" title="荣耀粉丝" />;
};

export {
  NickName,
  IdenPriv,
  IdenGuard,
  IdenAdmin,
  IdenCost,
  IdenLoveGroup,
  IdenMedal,
  IdenNewUser,
  IdenNum,
  IdenVip,
  IdenFamily,
  IdenMystic,
  HiddenMan,
  IdenHonorFans,
  IdenIos,
  IdenAndroid,
};
